































































































































































































import { listFactory } from '@/main/pages';
import SmsEmailModal from '@/modules/kartoteka/smsEmailModal/SmsEmailModal.vue';
import { SMS_TYP_PZN } from '@/modules/kartoteka/smsEmailModal/constants';
import { Partner } from '@/modules/kartoteka/partner/';
import { Pracovnik } from '@/modules/administrace/pracovnik';
// eslint-disable-next-line no-unused-vars
import { SmsEdit } from '@/modules/kartoteka/smsEmailModal/state';
import { apiProvider as smsEmailApiProvider } from '@/modules/kartoteka/smsEmailModal/api';
import { convertToObjects } from '@/main/utils/table';
import { dropdownListProvider } from '@/main/dropdownApi';
// eslint-disable-next-line no-unused-vars
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import _ from 'lodash';

import { DELKA_VIN, NAME, SDA_VIN_PREFIX } from './constants';
// eslint-disable-next-line no-unused-vars
import { Interval, store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		SmsEmailModal,
		PartnerSelect: Partner.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
	},
	data() {
		return {
			visibleSmsEmailModal: false,
			SMS_TYP_PZN,
		};
	},
	computed: {
		enableAddSdaVin(): boolean {
			if (this.Vozidlo.SdaVin.length === 0) return true;
			const { Od, Do } = _.last(this.Vozidlo.SdaVin)!;
			return !_.isNil(Od) && !_.isNil(Do);
		},
		isSmsDisabled(): boolean {
			return this.multipleSelection.length === 0;
		},
		mutationsMappers(): {} {
			return {
				jinyPlatce: `${this.storeUri}/${listMutations.JINY_PLATCE_FILTER_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${listMutations.PRACOVNIK_FILTER_SELECT_MAPPER}`,
				leasingZakaznik: `${this.storeUri}/${listMutations.LEASING_FILTER_SELECT_MAPPER}`,
				pojistovna: `${this.storeUri}/${listMutations.POISTOVNA_FILTER_SELECT_MAPPER}`,
				ProdejceprId: `${this.storeUri}/${listMutations.PRODEJCEPR_FILTER_SELECT_MAPPER}`,
			};
		},
		autoLoadItems(): boolean {
			return false;
		},
		ProdejceprIdFilter(): {} {
			return {};
		},
		zakaznikDruh(): DropdownItem[] {
			return [
				{ Text: this.Localize('FyzOsoba'), Label: null, Disabled: false, Value: 1 },
				{ Text: this.Localize('Firma'), Label: null, Disabled: false, Value: 2 },
				{ Text: this.Localize('Prodejce'), Label: null, Disabled: false, Value: 3 },
				{ Text: this.Localize('Interni'), Label: null, Disabled: false, Value: 4 },
				{ Text: this.Localize('fleetFleetZak'), Label: null, Disabled: false, Value: 5 },
			];
		},
	},
	watch: {
		enableSdaTyp(val): void {
			this.Vozidlo.SkodaNr = null;
			this.Vozidlo.TypSda = val ? 0 : null;
		},
	},
	methods: {
		odosliZpravu({ smsFormData }: { smsFormData: SmsEdit }) {
			this.visibleSmsEmailModal = false;
			this.startLoading();
			try {
				const { PovinnyText, VolitelnyText } = smsFormData;
				const Polozky = convertToObjects({ columns: this.table.columns, rows: this.multipleSelection });
				smsEmailApiProvider.hromadnaSmsSend({
					PovinnyText,
					VolitelnyText,
					Polozky,
				});
			} catch (e) {
				this.logError(e);
			} finally {
				this.endLoading();
			}
		},
		handleSelection(rows: []) {
			this.multipleSelection = rows;
		},
		OnVyrobekvozOznChange() {
			if (!this.Vozidlo.VyrobekvozOzn || this.Vozidlo.VyrobekvozOzn === '') {
				this.dropdownList.Tablpozice = [];
				this.dropdownList.Typkod = [];
			} else {
				dropdownListProvider.GetTablPoz(this.Vozidlo.VyrobekvozOzn!).then(({ data }) => {
					this.dropdownList.Tablpozice = data;
					this.dropdownList.Typkod = [];
				});
			}
		},
		OnTablpoziceChange(Tablpozice: string | number) {
			if (Tablpozice) {
				dropdownListProvider.GetTypKodMin4(this.Vozidlo.VyrobekvozOzn!, this.Vozidlo.Tablpozice!).then(({ data }) => {
					this.dropdownList.Typkod = data;
				});
			} else {
				this.dropdownList.Typkod = [];
				this.Vozidlo.Typkod = null;
			}
		},
		updateVinOd(value: string | null, index: number) {
			this.Vozidlo.SdaVin[index].Od = value;
			this.$nextTick(() => {
				(this.$refs.listLayout as any).mainForm.validateField(`Vozidlo.SdaVin[${index}].Do`);
			});
		},
		updateVinDo(value: string | null, index: number) {
			this.Vozidlo.SdaVin[index].Do = value;
			this.$nextTick(() => {
				(this.$refs.listLayout as any).mainForm.validateField(`Vozidlo.SdaVin[${index}].Od`);
			});
		},
		checkSdaVin(rule: { fullField: string }, value: string, callback: any) {
			const [, , indexStr] = rule.fullField.split(/[[\].]+/);
			const index: number = parseInt(indexStr, 10);
			const { Od, Do } = this.Vozidlo.SdaVin[index] as Interval<string>;

			if (value.length < SDA_VIN_PREFIX || _.isNil(value) || value.length < DELKA_VIN) {
				callback(new Error(this.Localize('BadDelkaVin')));
				return;
			}
			if (Od!.slice(0, 4) !== Do!.slice(0, 4)) {
				callback(new Error(this.Localize('BadFirstVin')));
			}
		},
		addSdaVin() {
			this.Vozidlo.SdaVin.push({ Od: '', Do: '' });
		},
		removeSdaVin() {
			this.Vozidlo.SdaVin.pop();
		},
		async filterClick() {
			const isValid = this.validate();
			if (isValid) {
				this.tableData();
			}
		},
	},
});
